module.exports = __webpack_public_path__ + "img/caja-paita.ef99fe0b.svg";